import React from 'react'

const EXAMPLE_IMAGES = {
  letter: 'https://abroad.imgix.net/abroad-website/Welcome_Letter.png',
  signup: 'https://abroad.imgix.net/abroad-website/Signup.png',
}

const EXAMPLE_COPY = {
  letter: {
    title: 'Welcome letter',
    lead: 'The first screen an invited guest sees, before they create an account.',
  },
  signup: {
    title: 'Signup page',
    lead: 'Guests create their account on this screen after the welcome letter.',
  },
}

const OnboardingExampleModal = ({ show, exampleKey, onHide }) => {
  if (!show || !exampleKey) {
    return null
  }

  const copy = EXAMPLE_COPY[exampleKey] || EXAMPLE_COPY.letter
  const imageSrc = EXAMPLE_IMAGES[exampleKey]

  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onHide()
    }
  }

  return (
    <div
      className='experience-copy-modal-backdrop open'
      role='dialog'
      aria-modal='true'
      aria-labelledby='onboardExampleTitle'
      onClick={handleBackdropClick}>
      <div className='experience-copy-modal-card experience-onboard-example-card'>
        <h2 id='onboardExampleTitle'>{copy.title}</h2>
        <p className='experience-copy-modal-lead'>{copy.lead}</p>
        <div className='experience-onboard-example-body'>
          {imageSrc ? (
            <img src={imageSrc} alt={`${copy.title} example`} />
          ) : null}
        </div>
        <div className='experience-copy-modal-actions'>
          <button
            type='button'
            className='btn-outline-experience'
            onClick={onHide}>
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default OnboardingExampleModal
